
import { defineComponent } from 'vue'
import AsahiButton from '@/components/library/AsahiButton.vue'
import AsahiTypography from '@/components/library/Typography.vue'
import InfoIcon from '@/components/library/icons/InfoIcon.vue'
import CheckIcon from '@/components/library/icons/CheckIcon.vue'

export default defineComponent({
  name: 'MessageModal',
  components: {
    AsahiButton,
    AsahiTypography,
    InfoIcon,
    CheckIcon
  },
  props: {
    message: {
      type: String,
      required: true
    },
    subMessage: {
      type: String,
      default: '',
      required: false
    },
    buttonText: {
      type: String,
      required: false,
      default: 'OK'
    },
    isErrorModal: {
      type: Boolean,
      required: false,
      default: false
    },
    showButton: {
      type: Boolean,
      default: true
    },
    hyperLink: {
      type: String,
      default: '',
      required: false
    },
    hyperLinkText: {
      type: String,
      required: false,
      default: ''

    },
    headerSubMsg: {
      type: String,
      required: false,
      default: ''
    }
  },

  emits: ['close'],

  methods: {
    close () {
      this.$emit('close')
    }
  }
})
